// The bridge VOCABULARY and its holds-identity gate. The DAEMON is the
// machine's authority — it owns the transitions and emits these frames; the SDK
// owns the names, and a source scan holds the two in agreement (sdk ADR-026).

export type BridgeStateName =
  | 'paused'
  | 'registering'
  | 'register_retrying'
  | 'register_refused'
  | 'connecting'
  | 'identifying'
  | 'connected'
  | 'backoff';

export type BridgeState =
  | { state: 'paused' }
  | { state: 'registering'; identity: string }
  | {
      state: 'register_retrying';
      identity: string;
      reason: string;
      attempt: number;
      retryInMs: number;
    }
  | { state: 'register_refused'; identity: string; reason: string; deviceId: string }
  | { state: 'connecting'; identity: string; deviceId: string }
  | { state: 'identifying'; identity: string; deviceId: string }
  | { state: 'connected'; identity: string; deviceId: string }
  | { state: 'backoff'; identity: string; reason: string; retryInMs: number };

/** The one wire vocabulary; `bridge.test.ts` scans the Rust actor against it. */
export const BRIDGE_FRAMES = {
  paused: 'bridge:paused',
  registering: 'bridge:registering',
  register_retrying: 'bridge:register_retrying',
  register_refused: 'bridge:register_refused',
  connecting: null,
  identifying: null,
  connected: 'bridge:connected',
  backoff: 'bridge:disconnected',
} as const satisfies { readonly [K in BridgeStateName]: string | null };

export type BridgeFrameEvent = Exclude<(typeof BRIDGE_FRAMES)[BridgeStateName], null>;

export const BRIDGE_FRAME_EVENTS: readonly BridgeFrameEvent[] = Object.values(BRIDGE_FRAMES).filter(
  (frame): frame is BridgeFrameEvent => frame !== null
);

export const ALL_BRIDGE_STATES = Object.keys(BRIDGE_FRAMES) as BridgeStateName[];

export function bridgeFrameOf(state: BridgeState): BridgeFrameEvent | null {
  return BRIDGE_FRAMES[state.state];
}

/** The gate is "holds identity", not "is usable". */
